import {useMemo} from 'react';
import type {GroupCallState} from '@phonehq/rtc-core';
import {callPeople} from '../../groupCalls/services/callPeople';

export interface CallPerson {
    readonly userId: string;
    readonly isLocal: boolean;
    readonly muted: boolean;
    readonly reconnecting: boolean;
}

export const callPeopleOf = (state: Pick<GroupCallState, 'participants'>): readonly CallPerson[] => {
    const byUser = new Map<string, Omit<CallPerson, 'userId'>>();
    state.participants.forEach(view => {
        const current = byUser.get(view.userId);
        byUser.set(view.userId, {
            isLocal: (current?.isLocal ?? false) || view.isLocal,
            muted: (current?.muted ?? true) && !view.microphoneEnabled,
            reconnecting: !view.inMedia && !view.isLocal,
        });
    });
    const people = new Set(callPeople([...byUser.keys()]));
    return [...byUser.entries()]
        .filter(([userId]) => people.has(userId))
        .map(([userId, person]) => ({userId, ...person}))
        .sort((left, right) => Number(right.isLocal) - Number(left.isLocal));
};

export const useCallPeople = (state: Pick<GroupCallState, 'participants'>): readonly CallPerson[] =>
    useMemo(() => callPeopleOf(state), [state]);
